import Core from '@/core/core/core';
import { useI18n } from '@/core/plugins/i18n';
import { isSafari } from '@/core/utils/device';

/**
 * Работа с буфером обмена
 * @packageDocumentation
 */

/**
 * Скопировать текст в буфер омбена
 */
export async function setClipboard(text: string, isInfoShowing = false) {
	let copyOk = false;

	if (navigator.clipboard) {
		await navigator.clipboard.writeText(text)
		copyOk = true;
		if (isInfoShowing) void Core.notice(useI18n().Common.Copied_to_clipboard + '', 'info');
	}

	return copyOk;
}

/**
 * Скопировать гостевую ссылку в буфер обмена
 */
export async function guestLinkToClipboard(link: string) {
	let isCopied = false;
	if (!isSafari()) isCopied = await setClipboard(link);

	const aLink = '<a href="' + link + '" target="_blank">' + link + '</a>';
	const copiedMessage = useI18n().Common.Copied_to_clipboard + `:\n` + aLink;

	if (isCopied) {
		void Core.notice(copiedMessage, 'info');
	} else {
		if (!navigator.clipboard) {
			void Core.notice(useI18n().Common.Cannot_copied_to_clipboard + `:\n` + useI18n().Common.Copy_guest_link_manually + `\n` + aLink, 'error');
			return;
		}

		const buttonProps = {
			onclick: () => setClipboard(link).then(() => Core.notice(copiedMessage, 'info')),
			default: useI18n().Common.Copy + '',
			class: 'copy',
		};

		await Core.notice(useI18n().Common.Guest_link_created + `\n` + aLink, 'info', { buttonProps });
	}
};
